import React, {useEffect, useState}      from 'react';
import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';
import { MdExpandMore, MdOutlineRemoveRedEye } from "react-icons/md";
import {
  actions as securityIncidentActions
} from '../../../ducks/securityIncidents/securityIncident.index';
import { Modal, Button, Tooltip, OverlayTrigger, Card, Row } from 'react-bootstrap';
import {parseHtmlFromDb} from '../SecurityIncidentHelpers';
/* ========= PACKAGE IMPORTS ========= */

const mapStateToProps = ({securityIncidentState}) => ({
  emailContents         : securityIncidentState.emailContents,
  emails                : securityIncidentState.emails,
  specificEmailsLoading : securityIncidentState.specificEmailsLoading,
});
const mapDispatchToProps =  (dispatch) => {
  const combinedActionCreators = {
    setEmailContents                : securityIncidentActions.setEmailContents,
    requestSpecificEmails           : securityIncidentActions.requestSpecificEmails,
    setEmailPreviewLoading          : securityIncidentActions.setEmailPreviewLoading,
    requestSendEmails               : securityIncidentActions.requestSendEmails,
  };

  return bindActionCreators(combinedActionCreators, dispatch);
};

const styles = {
  'icon': {
    'fontSize': '35px', 
    'color': '#007bff'
  },
  'iconDisabled': {
    'fontSize': '35px', 
    'color': '#007bff',
    'opacity': '0.55'
  }
};

const PreviewSendEmailModal = ({email, requestSendEmails, setEmailPreviewLoading, emailContents, setEmailContents, companyId, isButton=false, previewOnly=true, body="", subject="", clear=true, disableButton=false}) => {
  const [modalIsOpen,setIsOpen] = useState(false);
  const { icon, iconDisabled } = styles;
  useEffect(() => {
    if (body){
      setEmailContents(parseHtmlFromDb(null, body));
      setEmailPreviewLoading(false);
    }
  }, [modalIsOpen]);
  
  useEffect(() => {
    if (body){
      let stuff = parseHtmlFromDb(null, body);
      setEmailContents(stuff); 
    }
  }, [body]);

  useEffect(() => {
    if (email && email.body !== "" && emailContents.length === 0 && modalIsOpen){
      setEmailContents([]);
      setEmailContents(parseHtmlFromDb(null, email.body)); 
    }
  }, [email, modalIsOpen]);

  const openModal = () => {
    if (!disableButton){
      setIsOpen(true);
      if (clear){
        setEmailContents([]);
      }
    }
  }
  const closeModal = () => {
    setIsOpen(false);
  }

  const submitSend = () => {
    if (!previewOnly){
      requestSendEmails({'email_ids': [email.id]});
    }
    if (clear){
      setEmailContents([]);
    }
    closeModal();
  }

  return (
    <div style={{display: 'unset'}}>
      {isButton && <OverlayTrigger
        key='left'
        placement='left'
        overlay=
        {
          <Tooltip id={`tooltip-left`}>Preview email with option to send </Tooltip>
        }
      >
        <Button disabled={disableButton} style={{marginRight: '1rem'}} onClick={openModal}>Preview / Send</Button>
      </OverlayTrigger>}
      {!isButton && !previewOnly && <OverlayTrigger
        key='left'
        placement='left'
        overlay=
        {
          disableButton ? <Tooltip id={`tooltip-left`}>Disabled: {email['was_sent'] == 'N' ? ' No Recipient Count' : ' Email Already Sent'}</Tooltip> :  <Tooltip id={`tooltip-left`}>Preview email with option to send </Tooltip>
        }
      >
        <MdExpandMore onClick={openModal} style={disableButton ? iconDisabled : icon} ><Button ></Button></MdExpandMore>
      </OverlayTrigger>}
      {!isButton && previewOnly && <OverlayTrigger
        key='left'
        placement='left'
        overlay=
        {
          <Tooltip id={`tooltip-left`}>Preview email</Tooltip>
        }
      >
        <MdOutlineRemoveRedEye style={icon} onClick={openModal}/>
      </OverlayTrigger>}
     
      
      <Modal size='lg' show={modalIsOpen} onHide={closeModal} className="data-cy-preview-email-modal">
      {<div style={{textAlign: 'center'}}>
          {!previewOnly && <Modal.Header closeButton>
            <Modal.Title>Send Email</Modal.Title>
          </Modal.Header>}
          <Card>
            <Card.Body>
              
            {!previewOnly && <div>Confirm: Are you sure you want to send this?</div>}
              <br/>
              {!subject && <h3>{email.subject}</h3>}
              {subject && <h3>{subject}</h3>}
              <Row style={{justifyContent: 'center'}}>
                <div>Company Id:&nbsp;&nbsp;</div>
                <div>{companyId}</div>
              </Row>
              <br/>
              {emailContents.map((element, index) => {
                return (
                  <span style={{display: 'flex', justifyContent: 'center'}} key={index} className="Container">
                    {element}
                  </span>
                )})
              }
            </Card.Body>
          </Card>
          <div style={{display: 'flex'}}>
            <Button variant="secondary" onClick={closeModal} className="data-cy-preview-email-modal-close" style={{margin: '1vw', width: '8rem', marginRight: 'auto'}}>Cancel</Button>
            {!previewOnly && <Button variant="primary" onClick={() => submitSend()} style={{float: 'right', width: '8rem', margin: '1vw'}}>Send</Button>}
          </div>
        </div>}
      </Modal>
    </div>
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(PreviewSendEmailModal);